module.exports = __webpack_public_path__ + "media/romance.cbf3f519.mp3";